import {AfterViewInit, Component, OnInit} from '@angular/core';
import {StorageService} from '../../shared/services/storage.service';
import {CoreConfigService} from '../../../@core/services/config.service';
import {StateService} from '../../shared/services/state.service';
import {repeaterAnimation} from 'app/main/animations/form-repeater.animation';
import {AlertService} from '../../shared/services/alert.service';
import {NgbModal} from '@ng-bootstrap/ng-bootstrap';
import {FormBuilder} from '@angular/forms';
import {Router} from '@angular/router';
import {AnnouncementService} from '../../shared/services/announcement.service';
import {AppConstants} from '../../shared/constants/app-constant';
import {UserService} from '../../shared/services/user.service';
import {SessionService} from '../../shared/services/session.service';
import {UserOrderService} from '../../shared/services/user-order.service';
import {EarningService} from '../../shared/services/earning.service';
import {createLogErrorHandler} from '@angular/compiler-cli/ngcc/src/execution/tasks/completion';

@Component({
    selector: 'app-dashboard',
    templateUrl: './dashboard.component.html',
    styleUrls: ['./dashboard.component.scss'],
    animations: [repeaterAnimation]
})
export class DashboardComponent implements OnInit, AfterViewInit {
    user: any;
    states: any = [];
    data: any;
    id: any;
    public coreConfig: any;
    pagination = {
        page: 1,
        total: null,
        perpage: 15,
        pages: null
    };
    userInfo: any;
    announcement: any = [];
    announcementDetail: any;
    sessions: any = [];
    sessionId: any;
    submitting: any = false;
    userProductOrderCount: any = 0;
    userPackageCount: any = 0;
    userPairingBonusCount: any = 0;
    userMonthlyPairingBonusCount: any = 0;
    userDirectorBonusCount: any = 0;
    userDirectorTodayBonusCount: any = 0;
    selfRepurchaseTodaysBonusCount: any = 0;
    selfRepurchaseBonusCount: any = 0;
    performanceBonusCount: any = 0;
    performanceTodayBonusCount: any = 0;
    leadershipBonusCount: any = 0;
    leadershipTodayBonusCount: any = 0;
    carFundBonusCount: any = 0;
    carFundTodayBonusCount: any = 0;
    tourFundBonusCount: any = 0;
    tourFundTodayBonusCount: any = 0;
    houseFundBonusCount: any = 0;
    houseFundTodayBonusCount: any = 0;
    pendingLeftValue: any = 0;
    pendingRightValue: any = 0;
    equalValue: any;
    selfRepurchaseBasicValue: any = 0;
    totalBasicValue: any = 0;
    userRecentPackageCount: any = 0;
    selfRepurchaseTeamBasicValue: any = 0;
    userData: any;
    currentMonthBasicValueData: any;
    totalAmount: any = 0;
    walletAmount: any = 0;
    imageBaseUrl: any = AppConstants.BUCKET_URL;

    constructor(public _coreConfigService: CoreConfigService,
                public stateService: StateService,
                public modalService: NgbModal,
                private alertService: AlertService,
                private fb: FormBuilder,
                private router: Router,
                private announcementService: AnnouncementService,
                private sessionService: SessionService,
                private userOrderService: UserOrderService,
                private userService: UserService,
                private earningService: EarningService) {
        this.user = StorageService.getItem('self');
    }


    ngOnInit(): void {
    }

    ngAfterViewInit(): void {
        this.refresh();
    }

    refresh() {
        this.getSessions();
        this.getStates();
        this.getAnnouncement();
        this.getUserInfo();
        this.getUserDetail();
    }

    getSessions() {
        this.sessions = [];
        this.sessionService.get({'page': -1}).subscribe(data => {
            this.sessions = [];
            if (data && data['data'].length > 0) {
                this.sessions = data['data'];
                if (this.sessions && this.sessions.length > 0) {
                    this.sessions.forEach(session => {
                        if (session && session['status'] === 'ACTIVE' && session['default_session'] === 'ACTIVE') {
                            this.sessionId = session['id'];
                        }
                    });
                    this.getUserOrderCount();
                    this.getUserPackageCount();
                    this.getUserPairingBonusCount();
                    this.getUserMonthlyPairingBonusCount();
                    this.getUserDirectorBonusCount();
                    this.getUserDirectorTodaysBonusCount();
                    this.getSelfRepurchaseBonusCount();
                    this.getSelfRepurchaseTodaysBonusCount();
                    this.getPerformanceBonusCount();
                    this.getPerformanceTodayBonusCount();
                    this.getLeadershipBonusCount();
                    this.getLeadershipTodayBonusCount();
                    this.getCarFundBonusCount();
                    this.getCarFundTodayBonusCount();
                    this.getTourFundBonusCount();
                    this.getTourFundTodayBonusCount();
                    this.getHouseFundBonusCount();
                    this.getHouseFundTodayBonusCount();
                    this.getSelfRepurchaseBasicValue();
                    this.getSelfRepurchaseTeamBasicValue();
                    this.getUserRecentPackageCount();
                    this.getTotalBonuses();
                }
            }
            this.submitting = false;
        }, error => {
            this.submitting = false;
        });
    }

    getStates() {
        this.stateService.get().subscribe(data => {
            if (data && data['data'].length > 0) {
                this.states = data['data'];
            }
        });
    }


    getUserInfo(params: any = {}) {
        this.userService.get(params).subscribe(data => {
            if (data) {
                this.userInfo = data;
            }
        });

    }

    getUserOrderCount(params: any = {}) {
        params = {
            'session_id': this.sessionId,
        };
        this.userOrderService.getProductsCount(params).subscribe(data => {
            if (data) {
                this.userProductOrderCount = data;
            }
        });
    }

    getUserPackageCount(params: any = {}) {
        params = {
            'session_id': this.sessionId,
        };
        this.userOrderService.getPackagesCount(params).subscribe(data => {
            if (data) {
                this.userPackageCount = data;
            }
        });
    }

    getUserRecentPackageCount(params: any = {}) {
        params = {
            'session_id': this.sessionId,
        };
        this.userOrderService.getRecentPackagesCount(params).subscribe(data => {
            if (data) {
                this.userRecentPackageCount = data;
            }
        });
    }

    getUserPairingBonusCount(params: any = {}) {
        params = {
            'session_id': this.sessionId,
        };
        this.earningService.getPairingBonusCount(params).subscribe(data => {
            if (data) {
                this.userPairingBonusCount = Number(data.toFixed(2));
            }
        });
    }

    getUserMonthlyPairingBonusCount(params: any = {}) {
        params = {
            'session_id': this.sessionId,
        };
        this.earningService.getMonthlyPairingBonusCount(params).subscribe(data => {
            if (data) {
                this.userMonthlyPairingBonusCount = Number(data.toFixed(2));
            }
        });
    }

    getUserDirectorBonusCount(params: any = {}) {
        params = {
            'session_id': this.sessionId,
        };
        this.earningService.getDirectorBonusCount(params).subscribe(data => {
            if (data) {
                this.userDirectorBonusCount = parseFloat(data.toFixed(2));
            }
        });
    }


    getUserDirectorTodaysBonusCount(params: any = {}) {
        params = {
            'session_id': this.sessionId,
        };
        this.earningService.getDirectorTodayBonusCount(params).subscribe(data => {
            if (data) {
                this.userDirectorTodayBonusCount = data ? parseFloat(data.toFixed(2)) : this.userDirectorTodayBonusCount ;
            }
        });
    }

    getSelfRepurchaseBonusCount(params: any = {}) {
        params = {
            'session_id': this.sessionId,
        };
        this.earningService.getSelfRepurchaseBonusCount(params).subscribe(data => {
            if (data) {
                this.selfRepurchaseBonusCount = parseFloat(data.toFixed(2));
            }
        });
    }
    getSelfRepurchaseTodaysBonusCount(params: any = {}) {
        params = {
            'session_id': this.sessionId,
        };
        this.earningService.getSelfRepurchaseTodayBonusCount(params).subscribe(data => {
            if (data) {
                this.selfRepurchaseTodaysBonusCount = data ? parseFloat(data.toFixed(2)) : this.selfRepurchaseTodaysBonusCount ;
            }
        });
    }

    getPerformanceBonusCount(params: any = {}) {
        params = {
            'session_id': this.sessionId,
        };
        this.earningService.getPerformanceBonusCount(params).subscribe(data => {
            if (data) {
                this.performanceBonusCount = parseFloat(data.toFixed(2));
            }
        });
    }
    getPerformanceTodayBonusCount(params: any = {}) {
        params = {
            'session_id': this.sessionId,
        };
        this.earningService.getPerformanceTodayBonusCount(params).subscribe(data => {
            if (data) {
                this.performanceTodayBonusCount = data ? parseFloat(data.toFixed(2)) : this.performanceTodayBonusCount ;
            }
        });
    }

    getLeadershipBonusCount(params: any = {}) {
        params = {
            'session_id': this.sessionId,
        };
        this.earningService.getLeadershipBonusCount(params).subscribe(data => {
            if (data) {
                this.leadershipBonusCount = parseFloat(data.toFixed(2));
            }
        });
    }
    getLeadershipTodayBonusCount(params: any = {}) {
        params = {
            'session_id': this.sessionId,
        };
        this.earningService.getLeadershipTodayBonusCount(params).subscribe(data => {
            if (data) {
                this.leadershipTodayBonusCount =  data ? parseFloat(data.toFixed(2)) : this.leadershipTodayBonusCount ;
            }
        });
    }

    getCarFundBonusCount(params: any = {}) {
        params = {
            'session_id': this.sessionId,
        };
        this.earningService.getCarFundBonusCount(params).subscribe(data => {
            if (data) {
                this.carFundBonusCount = parseFloat(data.toFixed(2));
            }
        });
    }
    getCarFundTodayBonusCount(params: any = {}) {
        params = {
            'session_id': this.sessionId,
        };
        this.earningService.getCarFundTodayBonusCount(params).subscribe(data => {
            if (data) {
                this.carFundTodayBonusCount = data ? parseFloat(data.toFixed(2)) : this.carFundTodayBonusCount ;
            }
        });
    }

    getTourFundBonusCount(params: any = {}) {
        params = {
            'session_id': this.sessionId,
        };
        this.earningService.getTourFundBonusCount(params).subscribe(data => {
            if (data) {
                this.tourFundBonusCount = parseFloat(data.toFixed(2));
            }
        });
    }
    getTourFundTodayBonusCount(params: any = {}) {
        params = {
            'session_id': this.sessionId,
        };
        this.earningService.getTourFundTodayBonusCount(params).subscribe(data => {
            if (data) {
                this.tourFundTodayBonusCount = data ? parseFloat(data.toFixed(2)) : this.tourFundTodayBonusCount ;
            }
        });
    }

    getHouseFundBonusCount(params: any = {}) {
        params = {
            'session_id': this.sessionId,
        };
        this.earningService.getHouseFundBonusCount(params).subscribe(data => {
            if (data) {
                this.houseFundBonusCount = parseFloat(data.toFixed(2));
            }
        });
    }
    getHouseFundTodayBonusCount(params: any = {}) {
        params = {
            'session_id': this.sessionId,
        };
        this.earningService.getHouseFundTodayBonusCount(params).subscribe(data => {
            if (data) {
                this.houseFundTodayBonusCount = data ? parseFloat(data.toFixed(2)) : this.houseFundTodayBonusCount ;
            }
        });
    }

    /*getCountDirectSponsor(params: any = {}) {
        params = {
            'session_id': this.sessionId,
        };
        this.userService.getCountDirectSponsor(params).subscribe(data => {
            if (data) {
                this.countDirectSponsor = data;
            }
        });
    }*/

    getSelfRepurchaseBasicValue(params: any = {}) {
        params = {
            'session_id': this.sessionId,
        };
        this.userService.getSelfRepurchaseBasicValue(params).subscribe(data => {
            if (data) {
                this.selfRepurchaseBasicValue = parseFloat(data.toFixed(2));
            }
        });
    }

    getSelfRepurchaseTeamBasicValue(params: any = {}) {
        params = {
            'session_id': this.sessionId,
        };
        this.userService.getSelfRepurchaseTeamBasicValue(params).subscribe(data => {
            if (data) {
                this.selfRepurchaseTeamBasicValue = parseFloat(data.toFixed(2));
            }
        });
    }

    getUserDetail() {
        this.userService.selfDetail().subscribe(data => {
            if (data) {
                this.userData = data;
                this.walletAmount = (this.userData && this.userData['wallet_amount']) ? parseFloat(this.userData['wallet_amount']) : 0;
                const activationAmount = (this.userData && this.userData['activation_amount']) ? parseFloat(this.userData['activation_amount']) : 0;
                this.totalAmount = this.walletAmount + activationAmount;
                if (this.userData['user']['unbilled_basic_value_transactions']) {
                    this.currentMonthBasicValueData = JSON.parse(this.userData['user']['unbilled_basic_value_transactions']);
                    this.currentMonthBasicValueData.forEach(item => {
                        this.totalBasicValue += item.basic_value;
                    });
                }
                // tslint:disable-next-line:radix
                if (parseInt(this.userData.user.left_package_value) > parseInt(this.userData.user.right_package_value)) {
                    this.pendingLeftValue = (this.userData.user.left_package_value) - (this.userData.user.right_package_value);
                    // tslint:disable-next-line:radix
                } else if (parseInt(this.userData.user.left_package_value) < parseInt(this.userData.user.right_package_value)) {
                    this.pendingRightValue = (this.userData.user.right_package_value) - (this.userData.user.left_package_value);
                } else {
                    this.equalValue = 0;
                }

            }
        });
    }


    getAnnouncement(params: any = {}) {
        this.announcementService.get(params).subscribe(data => {
            if (data && data['data'] && data['data'].length > 0) {
                this.announcement = data['data'];
                this.announcement.forEach(data => {
                    this.announcementDetail = data;
                });
            }
        });
    }

    getTotalBonuses() {

    }

    goTo(url) {
        this.router.navigateByUrl(url);
    }

}
